import React, { useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css/pagination";
import { SassPlay } from "../../../../app-constants";

import test1Mp4 from "../../../images/home-update/testimonials/ams-reveiw-tekrevol-hd.mp4";
import test2Mp4 from "../../../images/home-update/testimonials/client-testimonial-jr-ridge-founder-of-guardian-angel.mp4";
import test3Mp4 from "../../../images/home-update/testimonials/client-testimonial-founder-talpool-bob-gamon.mp4";

import {
  HomeUpdatedTestArrow,
  HomeUpdatedTestUSFlag,
} from "../../../../app-constants";

export default function Testimonials() {
  // State to track which video is loaded/playing
  const [currentVideo, setCurrentVideo] = useState(null);
  const videoRefs = useRef([]);

  const handlePlayVideo = (index) => {
    // Pause all videos
    videoRefs.current.forEach((videoRef, i) => {
      if (videoRef && i !== index) {
        videoRef.pause();
      }
    });

    // Play the selected video
    setCurrentVideo(index);
    if (videoRefs.current[index]) {
      videoRefs.current[index].play();
    }
  };

  const [swiper, setSwiper] = React.useState();
  const prevRef = React.useRef();
  const nextRef = React.useRef();

  React.useEffect(() => {
    if (swiper) {
      console.log("Swiper instance:", swiper);
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  return (
    <section className="tekrevol__testimonials overflow-x-hidden p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={7} xl={7} xxl={7} className="">
            <div className="example example-bottom" data-text="Our Clients">
              <h2>What Our Clients Say About Us</h2>
            </div>
          </Col>
          {/* <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="d-flex justify-content-end">
                <Link to="https://clutch.co/profile/tekrevol" aria-label="What Our Clients Say About Us" className="btn-pri">
                    More Reviews
                </Link>
            </Col> */}
        </Row>

        <div className="slider-wrap">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={15}
            slidesPerView={1}
            pagination={{ clickable: true }}
            // navigation
            navigation={{
              prevEl: prevRef?.current,
              nextEl: nextRef?.current,
            }}
            onSwiper={setSwiper}
            onSlideChange={() => console.log("slide change")}
            className="test_slider"
          >
            <SwiperSlide>
              <Row className="align-items-center justify-content-center">
                <Col
                  xs={12}
                  md={12}
                  lg={12}
                  xl={6}
                  xxl={6}
                  className="img-wrap"
                >
                  <div className="img">
                    {currentVideo === 0 ? (
                      <video
                        controls
                        autoPlay
                        className="mw-100 test-video"
                        ref={(el) => (videoRefs.current[0] = el)}
                      >
                        <source src={test1Mp4} type="video/mp4" />
                      </video>
                    ) : (
                      <div className="video-thumbnail">
                        <StaticImage
                          src="../../../images/home-update/testimonials/test-image-1.webp"
                          alt="Ari Marinovsky"
                          className="img-fluid"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["auto"]}
                          width={646}
                          height={364}
                        />

                        <span
                          onClick={() => handlePlayVideo(0)}
                          className="play-btn"
                        >
                          {SassPlay}
                        </span>
                      </div>
                    )}
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  lg={12}
                  xl={6}
                  xxl={6}
                  className="content-wrap"
                >
                  <div className="content">
                    <span className="flag">{HomeUpdatedTestUSFlag} USA</span>
                    <h4>Melissa Montes</h4>
                    <p className="sub-title">
                      <span>CEO & Founder, Agent Monitoring</span>
                    </p>
                    <p>
                      "Since partnering with TekRevol in June of last year, our
                      experience has been nothing short of exceptional. As the
                      CEO and founder of a Breathalyzer alcohol monitoring
                      company, I was initially hesitant due to past experiences
                      with remote developers. However, TekRevol has consistently
                      exceeded our expectations with their top-notch
                      communication and support. Their team's dedication and
                      professionalism have earned my utmost respect. We look
                      forward to continuing our successful collaboration with
                      them."
                    </p>
                  </div>
                </Col>
              </Row>
            </SwiperSlide>
            <SwiperSlide>
              <Row className="align-items-center justify-content-center">
                <Col
                  xs={12}
                  md={12}
                  lg={12}
                  xl={6}
                  xxl={6}
                  className="img-wrap"
                >
                  <div className="img">
                    {currentVideo === 1 ? (
                      <video
                        controls
                        autoPlay
                        className="mw-100 test-video"
                        ref={(el) => (videoRefs.current[1] = el)}
                      >
                        <source src={test2Mp4} type="video/mp4" />
                      </video>
                    ) : (
                      <div className="video-thumbnail">
                        <StaticImage
                          src="../../../images/home-update/testimonials/test-image-2.webp"
                          alt="Ari Marinovsky"
                          className="img-fluid"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["auto"]}
                          width={646}
                          height={364}
                        />

                        <span
                          onClick={() => handlePlayVideo(1)}
                          className="play-btn"
                        >
                          {SassPlay}
                        </span>
                      </div>
                    )}
                  </div>
                </Col>
                <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="">
                  <div className="content">
                    <span className="flag">{HomeUpdatedTestUSFlag} USA</span>
                    <h4>J R Rich</h4>
                    <p className="sub-title">
                      <span>Founder of Guardian Angel</span>
                    </p>
                    <p>
                      "As the founder of Guardian Angel, I had a vision to
                      create an app that would notify family members immediately
                      in the event of an accident. When I decided to bring this
                      idea to life, TechRevol stood out among other development
                      companies. Their team instantly connected with my vision
                      and showed a genuine passion for creating apps that
                      improve lives. Throughout the development process, they
                      were not only receptive to my suggestions but also
                      proactive in providing valuable feedback to enhance the
                      app. As we near the release of the app, I am confident
                      that TekRevol will continue to be our innovation partner.
                      For anyone looking to develop an app, I highly recommend
                      TechRevol. Their dedication and expertise are truly
                      unmatched."
                    </p>
                  </div>
                </Col>
              </Row>
            </SwiperSlide>
            <SwiperSlide>
              <Row className="align-items-center justify-content-center">
                <Col
                  xs={12}
                  md={12}
                  lg={12}
                  xl={6}
                  xxl={6}
                  className="img-wrap"
                >
                  <div className="img">
                    {currentVideo === 2 ? (
                      <video
                        controls
                        autoPlay
                        className="mw-100 test-video"
                        ref={(el) => (videoRefs.current[2] = el)}
                      >
                        <source src={test3Mp4} type="video/mp4" />
                      </video>
                    ) : (
                      <div className="video-thumbnail">
                        <StaticImage
                          src="../../../images/home-update/testimonials/test-image-3.webp"
                          alt="Ari Marinovsky"
                          className="img-fluid"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["auto"]}
                          width={646}
                          height={364}
                        />

                        <span
                          onClick={() => handlePlayVideo(2)}
                          className="play-btn"
                        >
                          {SassPlay}
                        </span>
                      </div>
                    )}
                  </div>
                </Col>
                <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="">
                  <div className="content">
                    <span className="flag">{HomeUpdatedTestUSFlag} USA</span>
                    <h4>Bob Gammon</h4>
                    <p className="sub-title">
                      <span>Founder of Guardian Talpool</span>
                    </p>
                    <p>
                      "TekRevol has been instrumental in developing both my
                      mobile app and website. Their experience is unsurpassable,
                      and their team has provided remarkable support and
                      suggestions throughout the project. They are incredibly
                      responsive, whether making changes or developing new
                      features, and their expertise extends to social media and
                      beyond. I highly recommend TekRevol for anyone looking to
                      develop anything in the tech world. They have exceeded my
                      expectations and proven their value many times over."
                    </p>
                  </div>
                </Col>
              </Row>
            </SwiperSlide>
          </Swiper>
          <div ref={prevRef} className="custom-button custom-prev-button">
            {HomeUpdatedTestArrow}
          </div>
          <div ref={nextRef} className="custom-button custom-next-button">
            {HomeUpdatedTestArrow}
          </div>
        </div>
      </Container>
    </section>
  );
}
